/**
 * Mock Cognito Service (for local development)
 * This is a stub that provides the same interface as the real Cognito service
 * but doesn't require AWS Cognito to be configured.
 */

const cognitoService = {
  /**
   * Mock sign up - not implemented in development mode
   */
  async signUp(email, password, name) {
    console.warn('Mock Cognito: signUp not implemented in development mode');
    throw new Error('Authentication not configured');
  },

  /**
   * Mock confirm sign up - not implemented in development mode
   */
  async confirmSignUp(email, code) {
    console.warn('Mock Cognito: confirmSignUp not implemented in development mode');
    throw new Error('Authentication not configured');
  },

  /**
   * Mock sign in - not implemented in development mode
   */
  async signIn(email, password) {
    console.warn('Mock Cognito: signIn not implemented in development mode');
    throw new Error('Authentication not configured');
  },

  /**
   * Mock sign out - just clears local state
   */
  async signOut() {
    console.log('Mock Cognito: signOut');
    // Nothing to do in development mode
  },

  /**
   * Mock get current user - returns null
   */
  async getCurrentUser() {
    // No user in development mode
    return null;
  },

  /**
   * Mock get session - returns empty session
   */
  async getSession() {
    return {
      tokens: null,
    };
  },

  /**
   * Mock get ID token - returns null
   */
  async getIdToken() {
    // No token in development mode
    return null;
  },

  /**
   * Mock get user attributes - returns null
   */
  async getUserAttributes() {
    // No attributes in development mode
    return null;
  },
};

export default cognitoService;
